import { GOAL_STATUS, TIME_FRAME_TYPE, INCOME_TYPES, GOAL_ACTION_STATUS, PERFORMANCE_AREA, PERFORMANCE_METRICS } from "../constants/dataConstants";

export function getGoalStatusLabel(code: number | string) {
    const status = GOAL_STATUS.find(item => item.code === code);
    return status ? status.label : null;
  }

export function getGoalActionStatusLabel(code: number | string) {
    const status = GOAL_ACTION_STATUS.find((item) => item.code === code);
    return status ? status.label : null;
  }

export function getTimeFrameTypeLabel(code: number | string) {
    const timeFrameType = TIME_FRAME_TYPE.find(item => item.code === code);
    return timeFrameType ? timeFrameType.value : null;
  }

export function getIncomeTypeLabel(code: number | string) {
  const incomeType = INCOME_TYPES.find((item) => item.code === code);
  return incomeType ? incomeType.value : null;
}

export function getPerformanceAreaLabel(code: number | string) {
  const performanceArea = PERFORMANCE_AREA.find((item: Metric) => item.code === code);
  return performanceArea ? performanceArea.value : null;
}
export const getMetricLabel = (kpiCode: string): string => {
  for (const category in PERFORMANCE_METRICS) {
    const found = PERFORMANCE_METRICS[category].find((m: Metric) => m.code === kpiCode);
    if (found) return found.value;
  }
  return kpiCode;
};
  